import React, { useEffect, useState, useRef } from "react";
import Draggable from "react-draggable";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

function MobileCallModal({ open, onClose, agentData, payload }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [iframeSrc, setIframeSrc] = useState("");
  const [iframeError, setIframeError] = useState(false);
  const nodeRef = useRef(null); // Ref requerida por react-draggable

  useEffect(() => {
    if (open && agentData) {
      const baseUrl =
        process.env.REACT_APP_GINA_CALL_URL || "https://ginacr.wex.services/";
      const idAgent = payload?._id || "";
      const phoneTo = agentData?.to || "";
      const phoneFrom = agentData?.from || "";

      const generatedUrl = `${baseUrl}?idagente=${idAgent}&queue=SBADJ&tipo=outbound&To=${phoneTo}&From=${phoneFrom}&env=6`;
      setIframeSrc(generatedUrl);
      setIframeError(false);
    } else {
      setIframeSrc("");
      setIframeError(false);
    }
  }, [open, agentData, payload]);

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1300,
        pointerEvents: "none", // 🟢 PERMITE HACER CLIC Y ARRASTRAR EL MAPA DE ATRÁS
      }}
    >
      <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" disabled={isMobile}>
        <Paper
          ref={nodeRef}
          elevation={8}
          sx={{
            pointerEvents: "auto", // 🟢 MANTIENE INTERACTIVO EL MODAL DE LLAMADA
            position: "absolute",
            bottom: isMobile ? 0 : 20,
            right: isMobile ? 0 : 20,
            width: isMobile ? "100vw" : "420px",
            height: isMobile ? "100vh" : "600px",
            borderRadius: isMobile ? 0 : 3,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.25)",
          }}
        >
          {/* Encabezado Arrastrable */}
          <Box
            id="draggable-dialog-title"
            sx={{
              m: 0,
              p: 1.5,
              background: "linear-gradient(70deg, #7F8BFF, #55CEFF)",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: isMobile ? "default" : "move", // Indica que se puede mover
              userSelect: "none",
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Raleway, sans-serif",
                fontWeight: 600,
                fontSize: "0.95rem",
              }}
            >
              Llamada: {agentData?.name || "Ajustador"}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{ color: "white" }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Contenido del Iframe */}
          <Box sx={{ flex: 1, width: "100%", height: "100%", overflow: "hidden", bgcolor: "#fff" }}>
            {iframeSrc && !iframeError ? (
              <Box
                component="iframe"
                src={iframeSrc}
                title="Llamada de Agente"
                allow="microphone; camera; autoplay"
                allowFullScreen
                onError={() => setIframeError(true)}
                sx={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                }}
              />
            ) : iframeError ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  p: 2,
                  textAlign: "center",
                }}
              >
                <Typography variant="body2" sx={{ mb: 1.5 }}>
                  No se pudo cargar la llamada en la ventana flotante.
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => window.open(iframeSrc, "_blank")}
                  sx={{ backgroundColor: "#0c4a91" }}
                >
                  Abrir en pestaña nueva
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  Cargando interfaz de llamada...
                </Typography>
              </Box>
            )}
          </Box>
        </Paper>
      </Draggable>
    </Box>
  );
}

export default MobileCallModal;